
import { Component, Vue } from "vue-property-decorator";

@Component
export class TransationsAlertPage extends Vue {}
export default TransationsAlertPage;
